/* global Swiper */
$(() => {
  $('.js-news-slider').each(function sliderInit() {
    const $this = $(this);
    const swiper = new Swiper($this, {
      slidesPerView: 'auto',
      spaceBetween: 0,
    });
  });
});



// WEBPACK FOOTER //
// ./src/scripts/components/sliders/news-slider.js